import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import {
  startGetAdvertiserDefaultPlatformValues,
  startSaveAdvertiserDefaultPlatformValues,
} from "../../actions/platformDefaults";
import { SimpleAlert } from "../../components/Alerts/Alerts";
import {
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS,
} from "../../i18n/keysTranslations";
import { ALERT_ICON_TYPE_SUCCESS } from "../../utils/constants";
import { getPlatformDefaultsEmptyValues } from "../../utils/platformDefaults/platformDefaultsEmptyValues";

export const usePlatformDefaultsSettingsForm = ({ platform }) => {
  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();
  const emptyValues = getPlatformDefaultsEmptyValues({ platform });

  const formMethods = useForm({
    defaultValues: emptyValues,
  });

  const [isLoadingDefaults, setIsLoadingDefaults] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadDefaults = async () => {
      setIsLoadingDefaults(true);
      setSaveError("");

      const result = await dispatch(
        startGetAdvertiserDefaultPlatformValues({ platform })
      );

      if (!isMounted) {
        return;
      }

      formMethods.reset({
        ...emptyValues,
        ...(result?.ok && result.data ? result.data : {}),
      });
      setIsLoadingDefaults(false);
    };

    loadDefaults();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platform, dispatch]);

  const onSave = useCallback(async () => {
    setIsSaving(true);
    setSaveError("");

    const result = await dispatch(
      startSaveAdvertiserDefaultPlatformValues({
        platform,
        values: formMethods.getValues(),
      })
    );

    setIsSaving(false);

    if (result?.ok) {
      await SimpleAlert({
        title: t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS),
        icon: ALERT_ICON_TYPE_SUCCESS,
      });
      return;
    }

    setSaveError(t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR));
  }, [dispatch, formMethods, platform, t]);

  return {
    formMethods,
    isLoadingDefaults,
    isSaving,
    saveError,
    onSave,
  };
};
